import GenericQuickFilters from "./GenericQuickFilters";
import TagQuickFilters from "./TagQuickFilters";
import { ArchivedFilter, GroupBy, ProcessFilterType, ProcessFilterZod } from "@avenueops/shared-types";
import { useProcessTableState, useProcessTableFilters, useProcessTableQuickFilters, useProcessTableTimeFrame } from "context/ProcessTableContext";
import _ from "lodash";
import React, { useState } from "react";
import { useDebounce } from "use-debounce";

interface Props {
  isDashboard?: boolean;
  archived: ArchivedFilter;
}

export default function ProcessTableQuickFiltersSection({ isDashboard = false, archived }: Props) {
  const [timeFrameContextArgs] = useProcessTableTimeFrame();
  const [quickFilterType, setQuickFilterType] = useState<ProcessFilterType>("TAG");
  const { quickFilter, setQuickFilter, clearQuickFilter } = useProcessTableQuickFilters();
  const [filters, setFilters] = useProcessTableFilters();

  const [{ search }] = useProcessTableState();
  const [debouncedSearch] = useDebounce(search, 500);

  const isFilterActive = (filter: ProcessFilterZod) => {
    if (!filters || !filter) {
      return false;
    }
    return filters.some((f: ProcessFilterZod) => {
      return _.isEqual(f.type, filter.type) && _.isEqual(f.value, filter.value);
    });
  };

  const getQuickFilterClassName = (type: ProcessFilterType) => {
    if (quickFilterType === type) {
      return "bg-white text-gray-500 shadow-sm";
    } else {
      return "hover:bg-gray-100";
    }
  };

  return (
    <div className="bg-white border-y border-cool-gray-300 w-full ">
      <div className="divide-x select-none justify-start flex flex-row shadow-xs cursor-pointer w-full border-b border-gray-200 text-gray-400 text-center font-bold text-sm bg-gray-50">
        <div className={`truncate px-2 py-3 flex-auto ${getQuickFilterClassName("TAG")}`} onClick={() => setQuickFilterType("TAG")}>
          Tags
        </div>
        {isDashboard ? (
          <div className={`truncate px-2 py-3 flex-auto ${getQuickFilterClassName("STATUS")}`} onClick={() => setQuickFilterType("STATUS")}>
            Status
          </div>
        ) : (
          <div className={`truncate px-2 py-3 flex-auto ${getQuickFilterClassName("ASSIGNEE")}`} onClick={() => setQuickFilterType("ASSIGNEE")}>
            Assignees
          </div>
        )}
        <div className={`truncate px-2 py-3 flex-auto ${getQuickFilterClassName("WORKFLOW")}`} onClick={() => setQuickFilterType("WORKFLOW")}>
          Monitors
        </div>
      </div>
      {quickFilterType === "TAG" ? (
        <TagQuickFilters
          timeFrameContext={timeFrameContextArgs}
          filters={filters}
          isFilterActive={isFilterActive}
          setQuickFilter={setQuickFilter}
          clearQuickFilter={clearQuickFilter}
          archived={archived}
          isDashboard={isDashboard}
        />
      ) : (
        <GenericQuickFilters
          timeFrameContext={timeFrameContextArgs}
          filters={filters}
          isFilterActive={isFilterActive}
          setQuickFilter={setQuickFilter}
          clearQuickFilter={clearQuickFilter}
          debouncedSearch={debouncedSearch}
          groupBy={quickFilterType as GroupBy}
          archived={archived}
          isDashboard={isDashboard}
        />
      )}
    </div>
  );
}
